import styled from "styled-components";

export const Bigsection = styled.section`
margin: 0 2rem;
`